/**
 * Authentication & Authorization Capabilities
 * Defines user roles and permissions for AgileBrain Hub
 */
export enum Role {
  // AgileBrain Internal Roles
  AB_SUPER_ADMIN = 'ab_super_admin',
  AB_SCIENTIST = 'ab_scientist',
  AB_CSM = 'ab_csm',
  // Organization Roles
  ORG_SUPER_ADMIN = 'org_super_admin',
  ORG_ADMIN = 'org_admin',
  ORG_VIEWER = 'org_viewer',
  // School/Department Roles
  SCHOOL_ADMIN = 'school_admin',
  COUNSELOR = 'counselor',
  TEACHER = 'teacher',
  // Participant Roles
  PARENT = 'parent',
  STUDENT = 'student',
}

export interface UserScope {
  allowed_org_ids: string[]
  allowed_suborg_ids: string[]
  allowed_group_ids: string[]
  allowed_participant_ids: string[]
}

export interface User {
  id: string
  name: string
  email: string
  role: Role
  scope: UserScope
  lastActive: string
}

/**
 * Permission check utilities
 */
export const hasGlobalAccess = (role: Role): boolean => {
  return [Role.AB_SUPER_ADMIN, Role.AB_SCIENTIST, Role.AB_CSM].includes(role)
}

export const hasOrgAccess = (role: Role): boolean => {
  return (
    hasGlobalAccess(role) ||
    [Role.ORG_SUPER_ADMIN, Role.ORG_ADMIN].includes(role)
  )
}

export const canManageParticipants = (role: Role): boolean => {
  return (
    hasOrgAccess(role) || [Role.SCHOOL_ADMIN, Role.COUNSELOR].includes(role)
  )
}

export const canViewResults = (role: Role): boolean => {
  return (
    canManageParticipants(role) || [Role.TEACHER, Role.PARENT].includes(role)
  )
}
